import { selectSliceCisview } from '../../selectors/HELPERS';
import { ROOT_SLICE } from './constants';

export const selectThisSlice = state => {
	const slice = selectSliceCisview(state);
	return slice[ROOT_SLICE] || state;
};

export const selectItems = state => {
	const slice = selectThisSlice(state);
	const { items } = slice;
	return items;
};

export const selectItemsMap = state => {
	const slice = selectThisSlice(state);
	const { itemsMap } = slice;
	return itemsMap;
};

export const selectSubItemsMap = state => {
	const slice = selectThisSlice(state);
	const { subItemsMap } = slice;
	return subItemsMap;
};

export const selectIsLoading = state => {
	const slice = selectThisSlice(state);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = state => {
	const slice = selectThisSlice(state);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectCustomer = state => {
	const slice = selectThisSlice(state);
	const { customer } = slice;
	return customer;
};

export const selectErrorMessage = state => {
	const slice = selectThisSlice(state);
	const { errorMessage } = slice;
	return errorMessage;
};

// SELECTORS FOR DELETING

export const selectDeletingLinesAggsIds = state => {
	const slice = selectThisSlice(state);
	const { deletingLinesAggsIds } = slice;
	return deletingLinesAggsIds;
};

export const selectIsDeletingThisLineAgg = (state, lineAggId) => {
	const deletingLinesAggsIds = selectDeletingLinesAggsIds(state);
	return !!deletingLinesAggsIds[lineAggId];
};

// SELECTORS FOR DELETED

export const selectDeletedLinesAggsIds = state => {
	const slice = selectThisSlice(state);
	const { deletedLinesAggsIds } = slice;
	return deletedLinesAggsIds;
};

export const selectIsDeletedThisLineAgg = (state, lineAggId) => {
	const deletedLinesAggsIds = selectDeletedLinesAggsIds(state);
	return !!deletedLinesAggsIds[lineAggId];
};

// SELECTORS FOR DELETE ERROR MESSAGES

export const selectErrorMessagesForDeleting = state => {
	const slice = selectThisSlice(state);
	const { errorMessagesForDeleting } = slice;
	return errorMessagesForDeleting;
};

export const selectErrorMessageForDeletingThisLineAgg = (state, lineAggId) => {
	const errorMessagesForDeleting = selectErrorMessagesForDeleting(state);
	return errorMessagesForDeleting[lineAggId] || undefined;
};

export default {
	selectItems,
	selectItemsMap,
	selectSubItemsMap,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage,

	selectDeletingLinesAggsIds,
	selectIsDeletingThisLineAgg,

	selectDeletedLinesAggsIds,
	selectIsDeletedThisLineAgg,

	selectErrorMessagesForDeleting,
	selectErrorMessageForDeletingThisLineAgg
};
